export default __webpack_public_path__ + "static/media/trident-2.db8063ad.jpg";